import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  COMPRASREPORTES_MAIN,
  COMPRAS_ESTADOCUENTA,
  COMPRAS_NUEVO,
  COMPRAS_LISTA,
  COMPRASGUIAS_LISTA,
  COMPRASGUIAS_NUEVA
} from 'constants/codigosTransacciones'

import EstadoCuentaPage from './estado-cuenta'
import ListaPage from './lista'
import NuevaPage from './nueva'
import ReportesPage from './reporte'

export default function ComprasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${COMPRASGUIAS_LISTA}`} component={ListaPage} />
        <Route path={`/${COMPRASGUIAS_NUEVA}/:id`} component={NuevaPage} />
        <Route path={`/${COMPRASGUIAS_NUEVA}`} component={NuevaPage} />
        <Route path={`/${COMPRASREPORTES_MAIN}`} component={ReportesPage} />
        <Route path={`/${COMPRAS_ESTADOCUENTA}/:idCompra`} component={EstadoCuentaPage} />
        <Route path={`/${COMPRAS_NUEVO}/:id`} component={NuevaPage} />
        <Route path={`/${COMPRAS_NUEVO}`} component={NuevaPage} />
        <Route path={`/${COMPRAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
